import React from 'react';
import { useQueryClient } from 'react-query';
import useVenuesIndex from './useVenuesIndex';
import VenuesTable from './VenuesTable/VenuesTable';
import './VenuesIndexScreen.css';
import CityFilter from '../../ExploreScreen/CityFilter/CityFilter';

const VenuesIndexScreen: React.FC = () => {
  const { venues, isLoading, filters, applyFilters, handleUpdated, handleCreated } = useVenuesIndex();
  const queryClient = useQueryClient();
  const [isRefreshing, setIsRefreshing] = React.useState(false);

  const handleRefresh = async () => {
    setIsRefreshing(true);
    await queryClient.invalidateQueries('all-venues');
    setIsRefreshing(false);
  };

  if (isLoading) {
    return <div>טוענת...</div>;
  }

  return (
    <>
      <div className="venuesIndexScreen-header">
        <h1>ניהול מקומות</h1>
        <CityFilter value={filters.city} onChange={(newCity) => applyFilters({ city: newCity })} />
        <button type="button" onClick={handleRefresh} disabled={isRefreshing} style={{ marginRight: 10 }}>
          ⟳ רענון
        </button>
      </div>
      <VenuesTable
        venues={venues}
        filters={filters}
        applyFilters={applyFilters}
        onUpdated={handleUpdated}
        onCreated={handleCreated}
      />
    </>
  );
};

export default VenuesIndexScreen;
